export default __webpack_public_path__ + "static/media/stone_click.010d591f.mp3";